import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialHierarchy3: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.47 18.29H32v3.04h-1.53Zm-13.71 3.04v1.53h6.09v4.57h1.53v-4.57h6.09v-1.53zm-6.1-9.14h12.19v1.52H10.66Zm4.57 15.24v3.05h1.53v-1.53h6.09v-1.52z\"/><path fill=\"currentColor\" d=\"M30.47 18.29v-1.53h-6.09v-3.05h-1.53v3.05h-6.09v1.53zm-15.24 0h1.53v3.04h-1.53Zm0-16.77h1.53v3.05h-1.53ZM1.52 30.48h13.71V32H1.52Zm7.62-19.81h1.52v1.52H9.14Zm0-4.58h6.09V4.57H1.52v1.52h6.09v4.58h1.53zM1.52 25.9h13.71v1.53H1.52Zm0-25.9h13.71v1.52H1.52ZM0 27.43h1.52v3.05H0ZM0 1.52h1.52v3.05H0Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialHierarchy3
